import React from "react";
import { mergeKpiConfigs } from "../config";
import InfoTitle from "./InfoTitle";

const KpiTitle = ({ title, titleConfig, option }) => {
  ({ titleConfig } = mergeKpiConfigs(option, {
    titleConfig,
  }));

  return (
    <div>
      <InfoTitle title={title} {...titleConfig} />
    </div>
  );
};

export default KpiTitle;
